import { renderToString } from "react-dom/server";

const render = (jsx, parent) => {
  const htmlString = renderToString(jsx);
  parent.innerHTML = htmlString;
};

module.exports = { render, renderToString };
